// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BillableActionsMeterController from "./billable_actions_meter_controller"
import FormsController from "./forms_controller"
import NotificationsController from "./notifications_controller"
import PlaybookChatController from "./playbook_chat_controller"
import SuperAdminTemplatesController from "./super_admin_templates_controller"
import VariantChatController from "./variant_chat_controller"
import WebsiteController from "./website_controller"

application.register("billable-actions-meter", BillableActionsMeterController)
application.register("forms", FormsController)
application.register("notifications", NotificationsController)
application.register("playbook-chat", PlaybookChatController)
application.register("super-admin-templates", SuperAdminTemplatesController)
application.register("variant-chat", VariantChatController)
application.register("website", WebsiteController)
